import buildMatchPatternFn from '../../../_lib/buildMatchPatternFn/index';
import buildMatchFn from '../../../_lib/buildMatchFn/index';

const matchOrdinalNumberPattern = /^(\d+)(ya tatu|ya kwanza|ya pil|ya tatu)?/i;
const parseOrdinalNumberPattern = /\d+/i;

const matchEraPatterns = {
  narrow: /^(ቅልክ|ዓም)/i,
  abbreviated: /^(ቅልክ|ዓም)/i,
  wide: /^(ቅድመ ልደተ ክርስቶስ|ዓመተ ምህረት)/i,
};
const parseEraPatterns = {
  any: [/(^ቅልክ|^ቅድመ ልደተ ክርስቶስ)/i, /(^ዓም|^ዓመተ ምህረት)/i],
};

const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^[1234]ኛ ሩብ/i,
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/Q1/i, /Q2/i, /Q3/i, /Q4/i],
  wide: [/^1ኛ ሩብ/i, /2ኛ ሩብ/i, /3ኛ ሩብ/i, /4ኛ ሩብ/i],
};

const matchMonthPatterns = {
  narrow: /^(ጃ|ፌ|ማ|ኤ|ሜ|ጁን|ጁላ|ኦገ|ሴ|ኦክ|ኖ|ዲ)/i,
  abbreviated: /^(ጃንወ|ፌብሩ|ማርች|ኤፕሪ|ሜይ|ጁን|ጁላይ|ኦገስ|ሴፕቴ|ኦክቶ|ኖቬም|ዲሴም)/i,
  wide: /^(ጃንወሪ|ፌብሩወሪ|ማርች|ኤፕሪል|ሜይ|ጁን|ሁላይ|ኦገስት|ሴፕቴምበር|ኦክቶበር|ኖቬምበር|ዲሴምበር)/i,
};
const parseMonthPatterns = {
  narrow: [
    /^ጃ/i,
    /^ፌ/i,
    /^ማ/i,
    /^ኤ/i,
    /^ሜ/i,
    /^ጁን/i,
    /^ጁላ/i,
    /^ኦገ/i,
    /^ሴ/i,
    /^ኦክ/i,
    /^ኖ/i,
    /^ዲ/i,
  ],
  abbreviated: [
    /^ጃንወ/i,
    /^ፌብሩ/i,
    /^ማርች/i,
    /^ኤፕሪ/i,
    /^ሜይ/i,
    /^ጁን/i,
    /^ጁላይ/i,
    /^ኦገስ/i,
    /^ሴፕቴ/i,
    /^ኦክቶ/i,
    /^ኖቬም/i,
    /^ዲሴም/i,
  ],
  wide: [
    /^ጃንወሪ/i,
    /^ፌብሩወሪ/i,
    /^ማርች/i,
    /^ኤፕሪል/i,
    /^ሜይ/i,
    /^ጁን/i,
    /^ሁላይ/i,
    /^ኦገስት/i,
    /^ሴፕቴምበር/i,
    /^ኦክቶበር/i,
    /^ኖቬምበር/i,
    /^ዲሴምበር/i,
  ],
};

const matchDayPatterns = {
  narrow: /^(እ|ሰ|ማ|ረ|ሐ|ዓ|ቅ)/i,
  short: /^(እሁ|ሰኞ|ማክ|ረቡ|ሐሙ|ዓር|ቅዳ)/i,
  abbreviated: /^(እሁ|ሰ|ማክ|ረቡ|ሐሙ|ዓር|ቅዳሜ)/i,
  wide: /^(እሁድ|ሰኞ|ማክሰኞ|ረቡዕ|ሐሙስ|ዓርብ|ቅዳሜ)/i,
};
const parseDayPatterns = {
  narrow: [/^እ/i, /^ሰ/i, /^ማ/i, /^ረ/i, /^ሐ/i, /^ዓ/i, /^ቅ/i],
  short: [/^እሁ/i, /^ሰኞ/i, /^ማክ/i, /^ረቡ/i, /^ሐሙ/i, /^ዓር/i, /^ቅዳ/i],
  abbreviated: [/^እሁ/i, /^ሰ/i, /^ማክ/i, /^ረቡ/i, /^ሐሙ/i, /^ዓር/i, /^ቅዳሜ/i],
  wide: [/^እሁድ/i, /^ሰኞ/i, /^ማክሰኞ/i, /^ረቡዕ/i, /^ሐሙስ/i, /^ዓርብ/i, /^ቅዳሜ/i],
};

const matchDayPeriodPatterns = {
  narrow: /^(ጥዋት|ከሰዓት|እኩለ ሌሊት|ቀትር|ጥዋት|ከሰዓት በኋላ|ምሽት|ሌሊት)/i,
  abbreviated: /^(ጥዋት|ከሰዓት በኋላ|እኩለ ሌሊት|ቀትር|ጥዋት|ከሰዓት በኋላ|ምሽት|ሌሊት)/i,
  wide: /^(ጥዋት|ከሰዓት|እኩለ ሌሊት|ቀትር|ጥዋት|ከሰዓት በኋላ|ምሽት|ሌሊት)/i,
};
const parseDayPeriodPatterns = {
  narrow: {
    am: /^ጥዋት/i,
    pm: /^ከሰዓት/i,
    midnight: /^እኩለ ሌሊት/i,
    noon: /^ቀትር/i,
    morning: /ጥዋት/i,
    afternoon: /ከሰዓት በኋላ/i,
    evening: /ምሽት/i,
    night: /ሌሊት/i,
  },
  abbreviated: {
    am: /ጥዋት/i,
    pm: /ከሰዓት በኋላ/i,
    midnight: /እኩለ ሌሊት/i,
    noon: /ቀትር/i,
    morning: /ጥዋት/i,
    afternoon: /ከሰዓት በኋላ/i,
    evening: /ምሽት/i,
    night: /ሌሊት/i,
  },
  wide: {
    am: /ጥዋት/i,
    pm: /ከሰዓት/i,
    midnight: /እኩለ ሌሊት/i,
    noon: /ቀትር/i,
    morning: /ጥዋት/i,
    afternoon: /ከሰዓት በኋላ/i,
    evening: /ምሽት/i,
    night: /ሌሊት/i,
  },
};

const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    },
  }),

  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any',
  }),

  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    },
  }),

  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'wide',
  }),

  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'wide',
  }),

  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'wide',
  }),
};

export default match;
